import { Tooltip } from '@hotjar/webapp/components/Tooltip';
import type { IconName } from '@hotjar/hotsauce';
import { Icon } from '@hotjar/hotsauce';
import { TOOL_STATUS } from '@hotjar/webapp/constants/toolStatus';
import styled from '@emotion/styled';

import type { ALIAS_TEXT_COLORS } from '@hotjar/hotsauce/build/tokens/colors';

interface TrackingStateIconProps {
  status: StatusKey;
}

type StatusKey = keyof typeof TOOL_STATUS;

interface DefaultInfo {
  tooltipMessage: string;
  icon: IconName;
  color?: 'inherited' | keyof typeof ALIAS_TEXT_COLORS;
}

const StatusIcon = styled(Icon)``;

function getInfo(key: StatusKey): DefaultInfo | undefined {
  switch (key) {
    case TOOL_STATUS.active:
      return {
        tooltipMessage: 'Collecting data...',
        icon: 'play',
        color: 'text_success',
      };
    case TOOL_STATUS.complete:
      return {
        tooltipMessage: 'Completed.',
        icon: 'check',
        color: 'text_success',
      };
    case TOOL_STATUS.failed:
      return {
        tooltipMessage: 'Failed.',
        icon: 'error',
        color: 'text_error',
      };
    case TOOL_STATUS.neverActive:
      return {
        tooltipMessage: 'Install and verify your tracking code to start collecting data.',
        icon: 'error',
        color: 'text_error',
      };
    case TOOL_STATUS.paused:
      return {
        tooltipMessage: 'Paused.',
        icon: 'pause',
        color: 'text_warning',
      };
    case TOOL_STATUS.warning:
      return {
        tooltipMessage: 'No data received in the last 24 hours. Please verify your tracking code.',
        icon: 'warning',
        color: 'text_warning',
      };
    default:
      return undefined;
  }
}

export function TrackingStateIcon(props: TrackingStateIconProps): JSX.Element | null {
  const { status } = props;

  const info = getInfo(status);

  if (info === undefined) {
    return null;
  }

  return (
    <Tooltip content={info.tooltipMessage}>
      <StatusIcon icon={info.icon} color={info.color} />
    </Tooltip>
  );
}
